import React, { Component } from 'react';

// Styles.
import styles from './styles.module.scss';

export default class BackgroundGrid extends Component {

  render() {
    return (
      <div className={styles.mobileBGWrapper}>
        <div className={styles.mobileBG} />
      </div>
    );
  }

}
